import { ISystemReport } from "@dl/declarations";
import * as yup from "yup";

export type FormData = Pick<
  ISystemReport,
  "name" | "description" | "report_url" | "story_url"
> & {
  _id?: string;
  report_image: string;
  client_image: string;
  subtype: string;
  collections: string[];
  highlighted: boolean;
  highlight_report_cover: string;
  highlight_sponsor_logo: string;
  highlight_sponsor_logo_dark: string;
  highlight_section_title: string;
  highlight_section_content: string;
};

export const initialValues: FormData = {
  name: "",
  description: "",
  report_url: "",
  story_url: "",
  report_image: "",
  client_image: "",
  subtype: "",
  collections: [],
  highlighted: false,
  highlight_report_cover: "",
  highlight_sponsor_logo: "",
  highlight_sponsor_logo_dark: "",
  highlight_section_title: "",
  highlight_section_content: "",
};

export const schema = yup.object().shape({
  name: yup.string().required().label("Name"),
  description: yup.string().required().label("Description"),

  report_url: yup.string().url().label("Report URL"),
  story_url: yup.string().url().label("Story URL"),

  report_image: yup.string().required().label("Report Image"),
  client_image: yup.string().label("Client Image"),

  subtype: yup.string().required().label("Subtype"),

  collections: yup.array().of(yup.string()).optional().label("Collections"),

  highlighted: yup.boolean().label("Highlighted"),

  highlight_report_cover: yup.string().when("highlighted", {
    is: true,
    then: (schema) => schema.required().label("Report cover"),
    otherwise: (schema) => schema.optional().label("Report cover"),
  }),

  highlight_sponsor_logo: yup.string().optional().label("Sponsor mini logo"),
  highlight_sponsor_logo_dark: yup.string().optional().label("Sponsor mini logo (dark)"),

  highlight_section_title: yup.string().when("highlighted", {
    is: true,
    then: (schema) => schema.required().label("Section title"),
    otherwise: (schema) => schema.optional().label("Section title"),
  }),

  highlight_section_content: yup
    .string()
    .when("highlighted", {
      is: true,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label("Section content"),
});
